import { AppSettings } from './../../app.settings';
import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { filter, pairwise } from 'rxjs/operators';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { ErrorBindingService } from '../../services/error-binding.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html'
})
export class PageHeaderComponent implements OnInit, OnChanges {
  @ViewChild('input') autoFocus: ElementRef;
  breadCrumbArray: any[];
  headerStr: string;
  headerHidden = true;
  previousUrl: any;
  message: Message[] = [];
  messageSubscription: Subscription;
  constructor(private router: Router,
    private commonBindingDataService: CommonBindingDataService,
    private errorBindingService: ErrorBindingService) {
    this.router.events
      .pipe(filter((e: any) => e instanceof RoutesRecognized),
        pairwise()
      ).subscribe((e: any) => {
        this.previousUrl = e[0].urlAfterRedirects;
      });

    this.commonBindingDataService.title.subscribe(header => {
      this.headerStr = header;
    });
    this.breadCrumbArray = [];
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.previousUrl === '/signin' || this.previousUrl === undefined) {

        } else {
          this.autoFocus.nativeElement.focus();
        }
        this.fillBreadCrumbArray();
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe((url: any) => {
      if (AppSettings.HEADER_NOT_REQUIRED.includes(url.url)) {
        this.headerHidden = false;
      } else {
        this.headerHidden = true;
      }
    });

    this.messageSubscription = this.errorBindingService.message.subscribe(message => {
      this.message = [];
      if (message !== '') {
        this.message.push(message);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.fillBreadCrumbArray();
  }

  ngOnDestroy() {
    this.messageSubscription.unsubscribe();
  }

  fillBreadCrumbArray() {
    while (this.breadCrumbArray.length > 0) {
      this.breadCrumbArray.pop();
    }
    const currentObj = this;
    const url = this.router.url;
    let urlUpdated = url;
    if (url.lastIndexOf('?') > 0) {
      urlUpdated = url.split('?')[0];
    }

    const urlSplitArray = urlUpdated.split('/');
    let urlBuilder = '';
    const urlLength = urlSplitArray.length;
    let count = 0;
    urlSplitArray.forEach(element => {
      if (AppSettings.IGNORE_LINK.indexOf(element) === -1) {
        urlBuilder += element + '/';
        let visibleStr = '';
        let relativeUrl;
        if (element.length === 0) {
          visibleStr = 'Dashboard';
          relativeUrl = '#/bus-dashboard';
        } else {
          if (element.indexOf('dashboard') < 0) {
            visibleStr = currentObj.capitalizeFirstLetter(element);
            relativeUrl = urlBuilder;
            if (relativeUrl.endsWith('/')) {
              relativeUrl = relativeUrl.substring(0, relativeUrl.lastIndexOf('/'));
              relativeUrl = '#' + relativeUrl;
            }
          }
        }
        if (++count === urlLength) {
          if (url.split('?')[1] !== undefined) {
            relativeUrl = relativeUrl + '?' + url.split('?')[1];
          }
        }
        if (relativeUrl !== undefined) {
          currentObj.breadCrumbArray.push({ url: relativeUrl, name: decodeURIComponent(visibleStr) });
        }
      }
    });
    if (this.headerStr === '') {
      this.headerStr = this.breadCrumbArray[this.breadCrumbArray.length - 1].name.replace('>', '');
    }
  }

  capitalizeFirstLetter(str) {
    if (str !== undefined && str.length > 0) {
      str = str.replace(/-/g, ' ');
      const words = str.split(' ');
      let stringB = '';
      for (let index = 0; index < words.length; index++) {
        const w = words[index];
        if (w.length > 0) {
          stringB += w.charAt(0).toUpperCase() + w.slice(1);
        } else {
          stringB += w;
        }
        stringB += ' ';
      }
      return stringB.trim();
    }
    return str;
  }
}
